import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getTemplate, getTemplateVariableList, getTemplateVariables, listTemplate } from "./actions";

export const publishingTemplatesEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = publishingTemplatesEntityAdapter.getInitialState({
  isLoading: false,
  isInitialLoading: false,
  count: 0,
  currentPage: 1,
  hasMore: true,
  templateVariables: {},
  templateVariableList: [],
});

export const publishingTemplatesSlice = createSlice({
  name: "publishingTemplates",
  initialState: initialState,
  reducers: {
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
    resetTemplates: (state) => {
      publishingTemplatesEntityAdapter.removeAll(state);
      state.currentPage = 1;
      state.hasMore = true;
      state.isInitialLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listTemplate.pending, (state, action) => {
        state.isLoading = true;
        if (action.meta.arg.payload.page === 1) {
          state.isInitialLoading = true;
        }
      })
      .addCase(listTemplate.fulfilled, (state, action) => {
        if (!action.payload.error) {
          const { list, totalRecords } = action.payload.data;
          if (action.meta.arg.payload.page === 1) {
            publishingTemplatesEntityAdapter.setAll(state, list);
            state.isInitialLoading = false;
          } else {
            if (action.meta.arg?.resetList) {
              publishingTemplatesEntityAdapter.setAll(state, list);
            } else {
              publishingTemplatesEntityAdapter.upsertMany(state, list);
            }
          }
          state.count = totalRecords;
          state.currentPage = action.meta.arg.payload.page;
          state.hasMore = list.length > 0;
        } else {
          publishingTemplatesEntityAdapter.setAll(state, []);
          state.isInitialLoading = false;
        }
        state.isLoading = false;
      });
    builder.addCase(getTemplateVariables.fulfilled, (state, action) => {
      if (!action.payload.error) {
        state.templateVariables = action.payload.data;
      }
    });
    builder.addCase(getTemplateVariableList.fulfilled, (state, action) => {
      if (!action.payload.error) {
        state.templateVariableList = action.payload.data?.variables || [];
      }
    });
    builder.addCase(getTemplate.fulfilled, (state, action) => {
      if (!action.payload.error) {
        const data = action?.payload?.data;

        if (action?.meta?.arg?.payload?.fromRuleConfiguration) {
          data.fromRuleConfiguration = true;
        }

        publishingTemplatesEntityAdapter.upsertOne(state, data);
      }
    });
  },
});

export const { setSelectedTemplate, resetTemplates } = publishingTemplatesSlice.actions;

export default publishingTemplatesSlice.reducer;
